export enum PlanningStep {
  TrainingSelection = 0,
  TrainingInfo = 1,
  Duration = 2,
  Participants = 3,
  Documents = 4,
  Preview = 5,
}
